import type * as React from 'react';

import { CalendarCreateEventButton } from './CalendarCreateEventButton';

export interface CalendarCreateEventLeadsWrapperButtonProps {
  indId: number;
}

export const CalendarCreateEventLeadsWrapperButton = (
  props: CalendarCreateEventLeadsWrapperButtonProps
): React.JSX.Element => {
  return (
    <CalendarCreateEventButton
      indId={props.indId}
      element={
        <i
          className="far fa-calendar mt-2 text-info"
          data-toggle="tooltip"
          title="Set Appointment"
        ></i>
      }
    />
  );
};
